import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '商品名',
      dataIndex: 'tenantMaterialsName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantMaterialsName ? t.tenantMaterialsName : '-'
      },
    },
    {
      title: '规格',
      dataIndex: 'spec',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.spec ? t.spec : '-'
      },
    },
    {
      title: '厂家',
      dataIndex: 'originName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.originName ? t.originName : '-'
      },
    },
    {
      title: '剂型',
      dataIndex: 'doseCategory',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.doseCategory ? t.doseCategory : '-'
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.batchNo ? t.batchNo : '-'
      },
    },
    {
      title: '单位',
      dataIndex: 'unit',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.unit ? t.unit : '-'
      },
    },
    {
      title: '供应商',
      dataIndex: 'supplierName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierName ? t.supplierName : '-'
      },
    },
    {
      title: '有效期',
      dataIndex: 'periodValidity',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.periodValidity
          ? moment(t.periodValidity).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '销毁数量',
      dataIndex: 'destroyNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.destroyNumber ? t.destroyNumber : '-'
      },
    },
    {
      title: '销毁原因',
      dataIndex: 'destroyReason',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.destroyReason ? t.destroyReason : '-'
      },
    },
    {
      title: '销毁方式',
      dataIndex: 'destroyWay',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.destroyWay ? t.destroyWay : '-'
      },
    },
    {
      title: '销毁地址',
      dataIndex: 'destroyAddress',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.destroyAddress ? t.destroyAddress : '-'
      },
    },
    {
      title: '销毁日期',
      dataIndex: 'destroyDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.destroyDate
          ? moment(t.destroyDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '销毁人',
      dataIndex: 'destroyUserName',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.destroyUserName ? t.destroyUserName : '-'
      },
    },
    {
      title: '监督人',
      dataIndex: 'superviseUserName',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.superviseUserName ? t.superviseUserName : '-'
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t.remark : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '14rem',
      render: function Element(_, t) {
        return (
          <>
            {t?.examineStatus == 1 ? (
              <>
                <Button
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  onClick={() => {
                    onClick('lookDetail', t)
                  }}
                >
                  查看
                </Button>
              </>
            ) : (
              <>
                <Button
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  onClick={() => {
                    onClick('edit', t)
                  }}
                >
                  编辑
                </Button>
                <Button
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  disabled={t?.isEdit == 1 ? false : true}
                  onClick={() => {
                    onClick('audit', t)
                  }}
                >
                  审核
                </Button>
                <Button
                  danger
                  ghost
                  disabled={t?.isEdit == 1 ? false : true}
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  onClick={() => {
                    onClick('delete', t)
                  }}
                >
                  删除
                </Button>
              </>
            )}
          </>
        )
      },
    },
  ]
}
